import DetailedSaleLotModal from "./DetailedSaleLotModal";

export default DetailedSaleLotModal;
